import { Component } from '@angular/core';

@Component({
  selector: 'app-mint-failure',
  templateUrl: './mint-failure.component.html',
  styleUrls: ['./mint-failure.component.css', '../../../customerFace.css'],
  standalone: false
})

export class MintFailureComponent {

}
